import { PageActionOnValuesFunction } from '../types';
import { requestToVaryDeclaration } from './requestToVaryDeclaration';

const RequestToVary: PageActionOnValuesFunction = {
    requestToVaryDeclaration,
};

export default RequestToVary;
